<template>
  <component
    :is="component"
    v-bind="$attrs"
    class="btn"
    :type="htmlType"
    :disabled="disabled || loading"
    :tabindex="tabIndex"
    :class="[
      {
        'btn--disabled': disabled,
        'btn--loading': loading
      }
    ]"
    role="button"
    @click.capture="handleClick"
    @click.capture.native="handleClick"
  >
    <span
      v-if="iconLeft || loading"
      class="btn__content-icon"
      :class="{'btn__content-icon--left': !hideLabel}"
    >
      <v-icon
        v-if="!loading"
        :icon="iconLeft"
      />
      <v-icon
        v-if="loading"
        icon="spinner"
        spin
      />
    </span>
    <span
      v-if="!hideLabel"
      class="btn__content-text"
    >
      <slot>
        {{ label }}
      </slot>
    </span>
    <span
      v-if="iconRight"
      class="btn__content-icon"
      :class="{'btn__content-icon--right': !hideLabel}"
    >
      <v-icon :icon="iconRight" />
    </span>
  </component>
</template>

<script>
import VIcon from '@/components/VIcon';

export default {
  name: 'VButton',
  components: {
    VIcon,
  },
  inheritAttrs: false,
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    iconLeft: {
      type: String,
      default: null,
    },
    iconRight: {
      type: String,
      default: null,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: 'button',
    },
    label: {
      type: String,
      default: null,
    },
    hideLabel: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    htmlType() {
      if (this.component === 'button') {
        return this.type;
      }
      return '';
    },
    tabIndex() {
      if (this.loading || this.disabled) {
        return '-1';
      }

      return '0';
    },
    component() {
      if (this.$attrs.to) {
        return 'router-link';
      }
      if (this.$attrs.href) {
        return 'a';
      }
      return 'button';
    },
  },
  methods: {
    handleClick(event) {
      this.$emit('click', event);
    },
  },
};
</script>

<style lang="scss" src="./style.scss"></style>
